(function () {
  'use strict';

  var IMG_SEL = [
    '.media-gallery img',
    '.product-information__media img',
    '.product__media img',
    '[data-media-type="image"] img'
  ].join(', ');

  function extractColor(src, cb) {
    var proxy = new Image();
    proxy.crossOrigin = 'anonymous';

    proxy.onload = function () {
      try {
        var size = 80;
        var canvas = document.createElement('canvas');
        canvas.width = canvas.height = size;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(proxy, 0, 0, size, size);

        var px = ctx.getImageData(0, 0, size, size).data;
        var best = null, bestScore = 0;

        for (var i = 0; i < px.length; i += 4) {
          var r = px[i], g = px[i+1], b = px[i+2], a = px[i+3];
          if (a < 200) continue;
          var max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min;
          if (d < 25) continue;
          var l = (max + min) / 510;
          var s = d / Math.max(1, 255 * (1 - Math.abs(2 * l - 1)));
          var score = s * (1 - Math.pow((l - 0.45) * 2.2, 2));
          if (score > bestScore) { bestScore = score; best = [r, g, b]; }
        }

        // Fallback: average non-white
        if (!best) {
          var sr = 0, sg = 0, sb = 0, n = 0;
          for (var j = 0; j < px.length; j += 4) {
            if (px[j+3] < 200) continue;
            if (px[j] > 240 && px[j+1] > 240 && px[j+2] > 240) continue;
            sr += px[j]; sg += px[j+1]; sb += px[j+2]; n++;
          }
          if (n) best = [sr/n|0, sg/n|0, sb/n|0];
        }

        cb(best);
      } catch (e) { cb(null); }
    };

    proxy.onerror = function () { cb(null); };
    proxy.src = src.split('?')[0] + '?width=80&format=jpg';
  }

  function paint(color) {
    if (!color) return;
    var r = color[0], g = color[1], b = color[2];

    // Product details column
    var details = document.querySelector('.product-details');

    // Section background sits BEFORE .product-information in the DOM, not inside it
    var productInfo = document.querySelector('.product-information');
    var sectionBg = productInfo
      ? productInfo.previousElementSibling
      : document.querySelector('.section-background');

    if (details) {
      details.style.transition = 'background 0.8s ease';
      details.style.background =
        'radial-gradient(ellipse 160% 55% at 50% -5%,' +
        ' rgba(' + r + ',' + g + ',' + b + ',0.25) 0%,' +
        ' transparent 70%)';
    }

    if (sectionBg) {
      sectionBg.style.transition = 'background 0.8s ease';
      sectionBg.style.background =
        'radial-gradient(ellipse 60% 90% at 0% 35%,' +
        ' rgba(' + r + ',' + g + ',' + b + ',0.15) 0%,' +
        ' transparent 70%)';
    }
  }

  var lastSrc = '';

  function run() {
    var img = document.querySelector(IMG_SEL);
    if (!img) return;

    var src = img.currentSrc || img.src || img.getAttribute('data-src') || '';
    if (!src || src.indexOf('data:') === 0 || src === lastSrc) return;

    lastSrc = src;
    extractColor(src, paint);
  }

  function init() {
    // Try immediately, then retry as images lazy-load
    run();
    setTimeout(run, 300);
    setTimeout(run, 800);
    setTimeout(run, 2000);

    // Watch for variant image swaps
    var media = document.querySelector('.product-information__media, .media-gallery');
    if (media) {
      new MutationObserver(function () {
        lastSrc = '';
        run();
      }).observe(media, { subtree: true, attributeFilter: ['src', 'srcset'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
